import styled from "styled-components";

export const HandleHitArea = styled.div`
  left: ${({ $percent }) => `${$percent}%`};
  position: absolute;
  transform: translate(-50%, -50%);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  z-index: ${({ $memory }) => ($memory ? 1 : 5)};
  width: 28px;
  height: ${({ theme }) => `calc(${theme.filters.height.default} * 2)`};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "ew-resize")};
`;

export const HandleVisual = styled.div`
  left: ${({ $percent }) => `${$percent}%`};
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: ${({ $memory }) => ($memory ? 1 : 2)};
  width: ${({ theme }) => theme.filters.height.default};
  height: ${({ theme }) => theme.filters.height.default};
  border-radius: ${({ theme }) => theme.br.circle};
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.primary};
  opacity: ${({ $memory }) => ($memory ? 0.25 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "ew-resize")};
`;
